import * as React from 'react'
import { PillarSelectButton, SvgCarretDownIcon, SvgCarretLeftIcon } from '../LeftPanel.styled'
import { COLOR } from 'constant'

const PillarSelector: React.FC<{
  metricType: string
  color?: string
  weightValue: number
  onClick: () => void
  isOpen: boolean
  isDisabled: boolean
}> = ({ metricType, weightValue, onClick, isOpen, isDisabled }) => {
  return (
    <PillarSelectButton
      style={{
        background: weightValue ? COLOR.DARK : COLOR.WHITE,
        color: weightValue ? COLOR.TEXT : COLOR.NAVY,
        userSelect: 'none',
        textAlign: 'center',
        flex: '0 0 160px',
        lineHeight: 1,
      }}
      onClick={onClick}
      disabled={isDisabled}
    >
      <span style={{ width: '125px' }}>{metricType}</span>
      {isOpen ? (
        <SvgCarretLeftIcon iconColor={weightValue ? COLOR.TEXT : COLOR.CARRET} width='14px' height='14px' />
      ) : (
        <SvgCarretDownIcon iconColor={weightValue ? COLOR.TEXT : COLOR.CARRET} width='18px' height='18px' />
      )}
    </PillarSelectButton>
  )
}
export default PillarSelector
